<script setup lang="ts">
import { reactive } from 'vue';
import type { Message, Rating } from '../types/chat';
import thumbsUpIcon from '@fortawesome/fontawesome-pro/svgs/solid/thumbs-up.svg?raw';
import thumbsDownIcon from '@fortawesome/fontawesome-pro/svgs/solid/thumbs-down.svg?raw';

interface Props {
    message: Message;
}

const props = defineProps<Props>();

const handleFeedbackRating = (rating: Rating) => {
    if (!props.message.feedback) {
        props.message.feedback = reactive({ rating });
    } else {
        props.message.feedback.rating = rating;
    }
};
</script>

<template>
    <div v-if="props.message.feedback?.comment !== undefined" class="feedback-widget__confirmation-text" role="status" aria-live="polite">
        Vielen Dank für das Feedback!
    </div>

    <div
        v-else
        class="d-flex gap-1"
        role="group"
        aria-label="Antwort bewerten"
    >
        <button
            type="button"
            class="feedback-widget__button"
            :class="{ 'feedback-widget__button--active': props.message.feedback?.rating === 'positive' }"
            :aria-pressed="props.message.feedback?.rating === 'positive'"
            @click="handleFeedbackRating('positive')"
        >
            <span class="visually-hidden">Positive bewerten</span>
            <span v-html="thumbsUpIcon" class="feedback-widget__icon" aria-hidden="true"></span>
        </button>
        <button
            type="button"
            class="feedback-widget__button"
            :class="{ 'feedback-widget__button--active': props.message.feedback?.rating === 'negative' }"
            :aria-pressed="props.message.feedback?.rating === 'negative'"
            @click="handleFeedbackRating('negative')"
        >
            <span class="visually-hidden">Negativ bewerten</span>
            <span v-html="thumbsDownIcon" class="feedback-widget__icon" aria-hidden="true"></span>
        </button>
    </div>
</template>
